<template>
  <div v-if="frame" class="hotspot-tag">
    <div class="hotspot" v-bind:style=[styleObj] >
        <svg class="svgshape" :viewBox="shape.viewbox" width="100%" height="100%" preserveAspectRatio="none" stroke-width="1pt"  @click="onSVGClick">
          <path v-bind:d="shape.path" :style="svgStyles" vector-effect="non-scaling-stroke" />
        </svg>
    </div>
  </div>
</template>
<script>

import shapes from './../shapes/svgpath.json'
import { transparentColor } from './utils'
import { analytics } from './mixins/analytics/'

export default {
  name: 'hotspot',
  mixins: [analytics],
  props: ['hotspot', 'frame', 'isLastFrame', 'dimensions'],
  watch: {
    isLastFrame(isLast) {
      console.log('hotSpotTag isLastFrame %s. current frame %v', isLast, this.frame)
      if (isLast && this.onLastFrame.action !== 'none') {
        this.$emit('videoaction', this.onLastFrame)
      }
    },
    'hotspot': 'initTag' 
  },
  data() {
    return {
      shape: null
    }
  },
  computed: {
    styleObj: function() {
      var w = this.frame.pw * this.dimensions.w
      var h = this.frame.ph * this.dimensions.h
      var so = {
        'width': w + 'px',
        'height': h + 'px',
        'margin-top': (-h / 2) + 'px',
        'margin-left': (-w / 2) + 'px'
      }
      if (this.animation) {
        var a = this.animation
        let av = ''

        if (a.value) {
          av = `${a.animation} ${a.value || 2000}ms ${a.mode}`
        } else {
          av = `${a.animation} ${a.duration || 2}s infinite`
        }

        so['animation'] = av
      }
      return so
    },
    svgStyles: function() {
      var s = this.stroke || transparentColor()
      var f = this.fill || transparentColor()
      var sw = this.weight
      var so = {
        'stroke': `rgba(${s.r}, ${s.g}, ${s.b}, ${s.a})`,
        'fill': `rgba(${f.r}, ${f.g}, ${f.b}, ${f.a})`,
        'stroke-width': `${sw}px`
      }
      if (this.behaviour.action !== 'none') {
        so['cursor'] = 'pointer'
      }
      return so
    }
  },
  created() {
    console.log('hotspot created', this.hotspot)
    this.initTag()
  },
  methods: {
    initTag() {
      var meta = this.hotspot.meta
      var shapeObj = meta.shape
      this.shape = shapes[shapeObj.shape]
      this.fill = shapeObj.fill
      this.stroke = shapeObj.stroke
      this.weight = shapeObj.weight
      this.animation = meta.animation
      this.onLastFrame = meta.onLastFrame || {}
      this.behaviour = meta.behaviour || {}
      console.log('hotspot.inited', this.$vnode.tag, this.shape, this.stroke, this.fill)
    },
    update(i, value) {
    },
    onSVGClick(ev) {
      console.log('onSVGClick', this.behaviour)
      this.$emit('action', this.behaviour)
      this.trackTag("Hot Spot")
    }
  }
}

</script>
